import {Component, DestroyRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {NlrAssignPlanComponent} from '../../assign-plan/assign-plan.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NlrpDashboardResultService} from './dashboard-result.service';
import {NlrpInnerComponentService} from '../inner-component.service';
import {AlertModalService, ConfirmationModalService} from '../../../common/component/modal';
import {AmendReplaceLatestModalService} from '../../../common/component/modal/amend-replace-latest-modal/amend-replace-latest-modal.service';
import {PlanLodgementService} from '../../../common/service/plan-lodgement.service';
import {PlanModelService} from '../../../common/service/plan-model.service';
import {DASHBOARD_TAB, PLAN_ACTION, PDF_CREATION_METHOD_DESCRIPTION, TABS, ATTACHMENT_PLAN_PDF, LODGEMENT_TYPE} from '../../../common/constants';
import {NlrAssignPlanService} from '../../assign-plan/assign-plan.service';
import {currentPlan, DashboardFilters} from '../inner-component.model';
import {NgEventBus} from 'ng-event-bus';
import {catchError, concatMap, map} from 'rxjs/operators';
import {isDefined} from '../../../common/service/data-util';
import {AuthenticatorService} from '../../../common/service/authenticator.service';
import {NlrHasPermissionsPipe} from '../../../common/pipe/nlr-has-permissions.pipe';
import {NlrFocusDirective} from '../../../common/directive/nlr-focus.directive';
import {Observable, of, throwError} from 'rxjs';
import {PlanAttachment} from '../../../common/models/plan-attachment.model';
import {ModifyLodgedPlan} from 'src/app/common/models/modify-lodge-plan';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MapService} from '../../../design/services/map.service';
import {MapToolsService} from '../../../design/services/map-tools.service';
import {PermissionsService} from '../../../common/service/permissions.service';

@Component({
    selector: 'nlr-dashboard-result',
    imports: [RouterLink, CommonModule, FormsModule, NlrAssignPlanComponent, NlrHasPermissionsPipe, NlrFocusDirective],
    templateUrl: './dashboard-result.component.html',
    styleUrl: './dashboard-result.component.scss'
})
export class DashboardResultComponent implements OnInit {
    protected readonly PLAN_ACTION = PLAN_ACTION;
    protected readonly PDF_CREATION_METHOD_DESCRIPTION = PDF_CREATION_METHOD_DESCRIPTION;
    protected readonly DASHBOARD_TAB = DASHBOARD_TAB;

    title = TABS.DASHBOARD;

    sortBy = 'statusDate';
    sortDirection = 'asc';
    isAssignPlanModalOpen = false;
    isAmendment = false;
    selectedTab = DASHBOARD_TAB.IN_DESIGN;

    paginatedPlansData: currentPlan[] = [];

    //object to hold the sort column and the order for plans cases
    plansCasesSort = {
        reverse: true
    };

    showEditPlanButton = true;
    showAmendPlanButton = true;
    showViewPlanButton = true;
    showViewPlanPdfButton = true;
    showAssignPlanButton = true;
    showReplacePlanButton = true;
    showRemovePlanButton = true;
    showAdditionalsButton = true;

    editAdditionalsPermissions = ['EDIT_ADDITIONALS'];
    amendPlanPermissions = ['AMEND_PLAN'];
    replacePlanPermissions = ['REPLACE_PLAN'];
    viewPlanPermissions = ['VIEW_PLAN'];
    assignPlanPermissions = ['ASSIGN_PLAN'];
    editPlanPermissions = ['EDIT_PLAN'];

    @Input() set selectedDashboardTab(tabPlanType: string | null) {
        this.selectedTab = tabPlanType;
        if (tabPlanType) this.updateActionButtons(tabPlanType);
    }

    @Input()
    filters: DashboardFilters;

    @Output() assignPlanEvent = new EventEmitter<void>();
    @Output() deletePlanEvent = new EventEmitter<void>();
    @Output() resetFiltersEvent = new EventEmitter<void>();
    @Output() sortEvent = new EventEmitter<string>();
    @Output() modifyLodgedPlanEvent = new EventEmitter<ModifyLodgedPlan>();
    @Output() requestLatestLodgedVersion = new EventEmitter<any>();

    constructor(
        private authService: AuthenticatorService,
        private innerComponentService: NlrpInnerComponentService,
        private nlrpDashboardResultService: NlrpDashboardResultService,
        private nlrAssignPlanService: NlrAssignPlanService,
        private alertModalService: AlertModalService,
        private confirmationModalService: ConfirmationModalService,
        private amendReplaceLatestModalService: AmendReplaceLatestModalService,
        private planLodgementService: PlanLodgementService,
        private planModelService: PlanModelService,
        private eventBus: NgEventBus,
        private router: Router,
        private destroyRef: DestroyRef,
        private mapToolsService: MapToolsService,
        private permissionsService: PermissionsService
    ) {}

    isLodgeTabEnabled() {
        return this.selectedTab === DASHBOARD_TAB.LODGED;
    }

    ngOnInit() {
        this.innerComponentService.getPaginatedCurrentPlansData().subscribe(data => {
            this.paginatedPlansData = data;
        });
    }

    hasActionPermissions(names: string[]) {
        return this.permissionsService.getPermissions(names).length > 0;
    }

    updateActionButtons(tabPlanType: string) {
        if (
            tabPlanType === this.DASHBOARD_TAB.IN_DESIGN ||
            tabPlanType === this.DASHBOARD_TAB.READY_FOR_QA ||
            tabPlanType === this.DASHBOARD_TAB.READY_FOR_CERTIFICATION ||
            tabPlanType === this.DASHBOARD_TAB.CERTIFIED
        ) {
            this.showEditPlanButton = true;
            this.showAmendPlanButton = false;
            this.showViewPlanButton = true;
            this.showViewPlanPdfButton = true;
            this.showAssignPlanButton = true;
            this.showReplacePlanButton = false;
            this.showRemovePlanButton = true;
            this.showAdditionalsButton = false;
            this.selectedTab = tabPlanType;
        }

        if (tabPlanType === this.DASHBOARD_TAB.LODGED) {
            this.showEditPlanButton = false;
            this.showAmendPlanButton = true;
            this.showViewPlanButton = true;
            this.showViewPlanPdfButton = true;
            this.showAssignPlanButton = false;
            this.showReplacePlanButton = true;
            this.showRemovePlanButton = false;
            this.showAdditionalsButton = true;
            this.selectedTab = tabPlanType;
        }
    }

    editPlan(planSummarySelected: currentPlan) {
        console.debug(' editPlan ' + currentPlan);
        if (this.isPlanAssignedToCurrentUser(planSummarySelected)) {
            this.mapToolsService.init();
            this.router.navigate(['/plan/', PLAN_ACTION.EDIT, planSummarySelected.planLodgementId]);
        } else {
            const {planType, planNumber, assignedTo} = planSummarySelected;
            this.alertModalService.createAlertMessage(`${planType.toUpperCase()} ${planNumber} is assigned to ${assignedTo} and can not be edited`);
        }
    }

    lodgeAdditionals(planSummarySelected: currentPlan) {
        console.debug(`controller lodgeAdditionals` + currentPlan);
        this.router.navigate(['/plan/', PLAN_ACTION.LODGE_ADDITIONALS, planSummarySelected.planLodgementId]);
    }

    isPlanAssignedToCurrentUser(planSelected: currentPlan) {
        return (
            planSelected.assignedTo != null &&
            isDefined(planSelected.assignedTo) &&
            this.authService.getUsername().toLowerCase().trim() === planSelected.assignedTo.toLowerCase().trim()
        );
    }

    assignPlan(planSummarySelected: currentPlan) {
        const subs = this.planModelService
            .assign(planSummarySelected.assignedTo, planSummarySelected.assignedToName, planSummarySelected.planLodgementId)
            .subscribe({
                next: () => {
                    this.assignPlanEvent.emit();
                },
                error: error => {
                    console.error(`assignPlan error:`, error);
                    this.alertModalService.createAlertMessage([error]);
                },
                complete: () => {
                    this.alertModalService.createAlertMessage('The plan has been assigned successfully.', 'Ok', 'Plan assigned', 'success');
                }
            });

        this.eventBus.cast('nlr:busy', subs);
    }

    openAssignPlan(plan: currentPlan) {
        this.nlrAssignPlanService.updatePlanSummary(plan);
        this.isAssignPlanModalOpen = true;
    }

    dismissModal() {
        this.isAssignPlanModalOpen = false;
    }

    viewPdfOnlyPlan(planSelected: currentPlan) {
        console.debug(this.title + ' controller viewPdfOnlyPlan ' + planSelected);

        const subs = this.nlrpDashboardResultService
            .loadPlan(planSelected)
            .pipe(
                concatMap(model => {
                    if (model !== undefined) {
                        console.debug(this.title + ' success retrieving plan');
                        console.debug('Model on Load:' + JSON.stringify(model));
                        return this.displayPlan(model);
                    } else {
                        return throwError(() => {
                            new Error('Error lodging plan');
                        });
                    }
                }),
                catchError(error => {
                    return throwError(() => {
                        this.alertModalService.createAlertMessage(
                            'Attachment could not be retrieved. Please try again and if the problem persists please contact Landgate Customer Services.'
                        );
                        new Error(error);
                    });
                }),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe({
                next: data => {
                    if (data) {
                        const file = new Blob([data], {type: 'application/pdf'});
                        const fileURL = URL.createObjectURL(file);
                        const params = ['height=' + screen.height, 'width=' + screen.width, 'fullscreen=yes'].join(',');
                        let popup = window.open(fileURL, '_blank', params);
                        popup.moveTo(0, 0);
                        popup.onload = function () {
                            URL.revokeObjectURL(fileURL);
                        };
                    } else {
                        console.error('Error lodging plan');
                    }
                },
                error: error => {
                    const errorMessage = 'Error lodging case. Error: ' + error.message ? error.message : error;
                    console.error(errorMessage);
                }
            });

        this.eventBus.cast('nlr:busy', subs);
    }

    displayPlan(planLodgement: currentPlan): Observable<ArrayBuffer> {
        if (planLodgement !== undefined) {
            const attachments = planLodgement.attachments;
            if (attachments !== undefined && attachments.length > 0) {
                const filteredPlanPdfAttachments = attachments.filter((row: any) => {
                    return row.attachmentType === ATTACHMENT_PLAN_PDF && row.fileLocation;
                });

                if (filteredPlanPdfAttachments !== undefined && filteredPlanPdfAttachments.length > 0) {
                    return this.triggerPreviewPdf(filteredPlanPdfAttachments[0]);
                } else {
                    this.alertModalService.createAlertMessage('There is no Plan PDF attached to this Plan', 'OK', 'Information', 'info').pipe(
                        map(() => {
                            return of(null);
                        })
                    );
                }
            } else {
                this.alertModalService.createAlertMessage('There is no Attachments to this Plan', 'OK', 'Information', 'info').pipe(
                    map(() => {
                        return of(null);
                    })
                );
            }
        }
        return of(null);
    }

    triggerPreviewPdf(attachment: PlanAttachment): Observable<ArrayBuffer> {
        const uidWithPrefix = attachment.fileLocation.slice(attachment.fileLocation.lastIndexOf('/Other/'));
        return this.nlrpDashboardResultService.signedUrlForRetrieval(uidWithPrefix).pipe(
            concatMap(signedURL => {
                return this.nlrpDashboardResultService.previewPdf(signedURL);
            })
        );
    }

    viewPlan(planLodgementId: number) {
        this.router.navigate(['/plan/', ...Object.values({action: PLAN_ACTION.VIEW, planLodgementId})]);
    }

    removePlan(planSelected: currentPlan) {
        if (this.removePlanIsDisabled(planSelected)) {
            return;
        }
        this.confirmationModalService
            .showModal({
                title: 'Warning',
                confirmationText: 'You are about to remove this plan. Are you sure you wish to continue?',
                action: 'dashboard-result:remove-plan'
            })
            .subscribe({
                next: (res: string) => {
                    if (res === 'dashboard-result:remove-plan') {
                        const subs = this.planLodgementService.remove(planSelected.planLodgementId).subscribe(() => {
                            this.deletePlanEvent.emit();
                            this.alertModalService.createAlertMessage('The plan has been removed.', 'Ok', 'Plan removed', 'success');
                        });
                        this.eventBus.cast('nlr:busy', subs);
                    }
                },
                error: () => {
                    const errorMessage = 'Error removing case';
                    this.alertModalService.createAlertMessage(errorMessage);
                }
            });
    }

    removePlanIsDisabled(plan: currentPlan) {
        if (!plan.creator || !plan.assignedTo) {
            return true;
        }

        const assignedTo = plan.assignedTo.toLowerCase();
        const creator = plan.creator.toLowerCase();
        const userName = this.authService.getUsername().toLowerCase();
        return creator !== userName && assignedTo !== userName;
    }

    resetFilters() {
        this.resetFiltersEvent.emit();
    }

    sortColumn(columnName: string, reverseByDefault?: boolean) {
        this.sortEvent.emit(columnName);
        reverseByDefault = reverseByDefault || false;
        this.plansCasesSort.reverse = this.sortBy === columnName ? !this.plansCasesSort.reverse : reverseByDefault;
        this.sortBy = columnName;
    }

    isSortedBy(columnName: string) {
        return columnName === this.sortBy;
    }

    amendPlan(planSelected: currentPlan) {
        this.isAmendment = true;
        this.requestLatestLodgedVersion.emit(planSelected);
    }

    replacePlan(planSelected: currentPlan) {
        this.requestLatestLodgedVersion.emit(planSelected);
    }

    amendReplacePlanHandleLatestVersion(response: Observable<any>) {
        response.subscribe(response => {
            if (response.latestPlan !== undefined) {
                if (this.isAmendment) {
                    if (response.planSelected.version === response.latestPlan.version) {
                        this.modifyLodgedPlan(response.planSelected, LODGEMENT_TYPE.AMENDMENT, PLAN_ACTION.AMEND, false);
                    } else {
                        this.amendReplaceLatestDialog(response.planSelected, LODGEMENT_TYPE.AMENDMENT, PLAN_ACTION.AMEND);
                    }
                } else {
                    if (response.planSelected.version === response.latestPlan.version) {
                        this.modifyLodgedPlan(response.planSelected, LODGEMENT_TYPE.REPLACEMENT, PLAN_ACTION.REPLACE, false);
                    } else {
                        this.amendReplaceLatestDialog(response.lanSelected, LODGEMENT_TYPE.REPLACEMENT, PLAN_ACTION.REPLACE);
                    }
                }
            }
        });
    }

    modifyLodgedPlan(planSelected: currentPlan, lodgementType: string, action: string, useLatest: boolean) {
        console.debug(this.title + ' controller modify lodged plan ' + planSelected);
        this.modifyLodgedPlanEvent.emit({planSelected: planSelected, lodgementType: lodgementType, action: action, useLatest: useLatest});
    }

    amendReplaceLatestDialog(planSummarySelected: currentPlan, lodgementType: string, action: string) {
        const title = 'Warning';
        const message = 'Please confirm you would like to proceed with the chosen version or use the latest version';
        this.amendReplaceLatestModalService.showAmendReplaceLatestModal(title, message).subscribe((useLatest: boolean) => {
            console.debug(this.title + 'useLatest ' + useLatest);
            this.modifyLodgedPlan(planSummarySelected, lodgementType, action, useLatest);
        });
    }
}
